/**
 * AUTHENTICATION STORE
 *
 * http://vaughnroyko.com/saving-and-loading-objects-or-arrays-in-localstorage/
 */
import Vue from "vue";
import api from "Api";
import router from "Router";
import { getCurrentUser } from "Core/users/config/api.users";
import { store } from "Store/store";

const state = {
    current_user: localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user"))
        : $cookies.isKey("token") && localStorage.getItem("current_user") == null
        ? fetchCurrentUser()
        : null,
    token: $cookies.get("token") ? $cookies.get("token").token : "",
    loginFlag: false,
    auth_user_id_array: ["1", "10"],
};

async function fetchCurrentUser() {
    try {
        let response = await getCurrentUser();
        store.commit("setCurrentUser", response.data.user);
    } catch (error) {
        throw error;
    }
}

// getters
const getters = {
    getLoginFlag: (state) => {
        return JSON.parse(state.loginFlag);
    },
    user_is_dev: (state) => {
        return state.current_user ? state.auth_user_id_array.includes(state.current_user.user_id) : false;
    },
};

// actions
const actions = {
    async signinUserIn({ rootState, commit, dispatch }, payload) {
        const user = payload.user;
        var redirectURL = payload.redirect;
        commit("logoutUser", false);
        try {
            let response = await api.get("authenticate/login", {
                auth: {
                    username: user.username,
                    password: user.password,
                },
                params: {
                    remember_me: user.remember_me,
                    build_version: document.documentElement.dataset.buildTimestampUtc,
                },
            });
            if (typeof response !== "undefined") {
                commit("loginUserSuccess", {
                    data: response.data,
                    redirect: redirectURL,
                });

                //dispatch("hideLoader");

                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw error;
        }
    },
    async signinUserInRfid({ rootState, commit, dispatch }, payload) {
        var redirectURL = payload.redirect;
        commit("logoutUser", false);
        //console.log("signinUserInRfid:", payload);
        try {
            let response = await api.post("authenticate/rfid", {
                rfid: payload.rfid,
            });
            //("response", response);
            if (typeof response !== "undefined") {
                commit("loginUserSuccess", {
                    data: response.data,
                    redirect: redirectURL,
                });

                //dispatch("hideLoader");

                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw error;
        }
    },
    async signinUserInQr({ rootState, commit }, payload) {
        var redirectURL = payload.redirect;
        commit("logoutUser", false);
        //console.log("signinUserInQr:", payload);
        try {
            let response = await api.post("authenticate/qr", {
                qr_code: payload.qr_code,
            });
            //console.log("response", response);
            if (typeof response !== "undefined") {
                commit("loginUserSuccess", {
                    data: response.data,
                    redirect: redirectURL,
                });

                //dispatch("hideLoader");

                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw error;
        }
    },
    logoutUser({ rootState, commit, dispatch }, payload) {
        //commit("startLoader");
        dispatch("showLoader");
        //api.defaults.headers.common['Authorization'] = token
        setTimeout(() => {
            commit("logoutUser", {
                returnToLogin: payload && payload.toLogin ? payload.toLogin : false,
            });
        }, 500);
    },
    async requestPasswordReset({ rootState, commit }, payload) {
        let body = "";
        body = JSON.stringify(payload.body);

        try {
            let response = await api.post("authenticate/request_reset", body);

            if (typeof response !== "undefined") {
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async setNewPassword({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }
            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }
            if (typeof response !== "undefined") {
                return response.data;
            }
        } catch (error) {
            throw error;
        }
    },
    async checkForgotCode({ rootState, commit }, payload) {
        let reset_id = ""; // language: rootState.authStore.currentLocale.locale

        reset_id = payload.body;

        try {
            let response = await api.get("authenticate/request_reset/" + reset_id);
            if (typeof response == "undefined") {
                router.push({ name: "forgot_password" });
                //router.push({ path: "/session/forgot_password" });
            }
        } catch (error) {
            throw error;
        }
    },
    async uploadMyPhoto({ rootState, commit }, payload) {
        try {
            let response = await api.post(payload.url, payload.body);

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("commitCurrentUser", {
                        property: ["current_user.photo", "current_user.photo_thumb"],
                        with: [response.data.person.photo, response.data.person.photo_thumb],
                    });
                    if (payload.localStorage) {
                        let userItem = JSON.parse(localStorage.getItem("current_user"));
                        userItem.photo = response.data.person.photo;
                        userItem.photo_thumb = response.data.person.photo_thumb;
                        localStorage.setItem("current_user", JSON.stringify(userItem));
                    }
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async checkCurrentuser({ rootState, commit }) {
        if (localStorage.getItem("current_user") == null) {
            try {
                fetchCurrentUser();
            } catch (error) {
                throw error;
            }
        }
    },
};

// mutations
const mutations = {
    commitCurrentUser(state, payload) {
        if (_.isArray(payload.property)) {
            for (let i = 0; i < payload.property.length; i++) {
                _.set(state, payload.property[i], payload.with[i] || null);
            }
        } else {
            _.set(state, payload.property, payload.with || null);
        }
    },
    loginUserSuccess(state, response) {
        // SET AUTH TOKEN
        var data = response.data;
        state.token = data.token;
        var redirectURL = response.redirect;
        $cookies.set("token", { token: data.token, token_expires: data.token_expires }, new Date(data.token_expires).toUTCString(), null, null, true, "Strict");
        //api.defaults.headers.common['Token'] = state.token
        api.defaults.headers.common["Authorization"] = "Bearer " + state.token;
        localStorage.setItem("current_user", JSON.stringify(data.user));
        var user_info = JSON.parse(localStorage.getItem("current_user"));
        state.current_user = user_info;

        if (window.innerWidth > 1264) {
            // manually check if desktop view
            localStorage.setItem("drawer", true); // on login default drawer open
        } else {
            localStorage.setItem("drawer", false); // on login default drawer closed
        }

        /* load notifications */
        state.loginFlag = true;
        /* account/dashboard */
        if (decode(redirectURL) && decode(redirectURL) != "null") {
            router.push(decode(redirectURL));
        } else {
            // if (user_info.slug == "customer") {
            //     router.push("/");
            // } else {
            //     router.push({ name: "dashboard" });
            // }
            if (user_info.default_route && user_info.default_route != null) {
                router.push({ name: user_info.default_route });
            } else {
                router.push({ name: "dashboard" });
            }
        }
        /* console/dashboard" */

        // VueNotifications.success({ message: 'User Logged In Success!' });
    },
    logoutUser(state, payload) {
        // state.current_user = null;

        // state.user_id = null;
        localStorage.removeItem("user_id");

        api.get("authenticate/logout").then(function (response) {
            if (typeof payload !== "undefined" && payload.returnToLogin) {
                if (payload.redirect && encode(payload.redirect) && encode(payload.redirect) !== null) {
                    //delete api.defaults.headers.common['Token'];
                    delete api.defaults.headers.common["Authorization"];

                    localStorage.removeItem("current_user");
                    $cookies.remove("token");
                    $cookies.keys().forEach((cookie) => $cookies.remove(cookie));
                    localStorage.clear();
                    state.token = "";

                    let encodedPath = encode(payload.redirect);
                    router.push("/session/login" + (encodedPath && encodedPath.length > 0 ? "/" + encodedPath : "")).catch(() => {});
                } else {
                    //delete api.defaults.headers.common['Token'];
                    delete api.defaults.headers.common["Authorization"];

                    localStorage.removeItem("current_user");
                    $cookies.remove("token");
                    $cookies.keys().forEach((cookie) => $cookies.remove(cookie));
                    localStorage.clear();
                    state.token = "";

                    router.push("/session/login").catch(() => {});
                }
            } else {
                //delete api.defaults.headers.common['Token'];
                delete api.defaults.headers.common["Authorization"];

                localStorage.removeItem("current_user");
                $cookies.remove("token");
                $cookies.keys().forEach((cookie) => $cookies.remove(cookie));
                localStorage.clear();
                state.token = "";

                router.push("/session/login").catch(() => {});
            }
        });

        // VueNotifications.success({ message: 'User logged out!' });

        //delete api.defaults.headers.common['Token'];
        delete api.defaults.headers.common["Authorization"];

        localStorage.removeItem("current_user");
        $cookies.remove("token");
        $cookies.keys().forEach((cookie) => $cookies.remove(cookie));
        localStorage.clear();
        state.token = "";
    },
    signUpUser(state, dispatch) {
        //commit("startLoader");
        dispatch("showLoader");
    },
    signUpUserSuccess(state, user_id) {
        //state.user_id = localStorage.setItem('user_id', user_id);
        // console/dashboard
        router.push("/");
        // VueNotifications.success({ message: 'Account Created!' });

        setTimeout(function () {
            Vue.notify({
                group: "loggedIn",
                type: "success",
                text: "Account created!",
            });
        }, 1500);
    },
    signUpUserFailure(state, dispatch, error) {
        dispatch("hideLoader");
        //VueNotifications.error({ message: error.message });

        setTimeout(function () {
            Vue.notify({
                group: "loggedIn",
                type: "error",
                text: error.message,
            });
        }, 1500);
    },
    resetLoginFlag() {
        state.loginFlag = false;
    },
    updateUser(state, response) {
        let userItem = JSON.parse(localStorage.getItem("current_user"));
        for (const [key, value] of Object.entries(response)) {
            userItem[key] = value;
        }
        localStorage.setItem("current_user", JSON.stringify(userItem));
        state.current_user = JSON.parse(JSON.stringify(userItem));
    },
    setCurrentUser(state, response) {
        localStorage.setItem("current_user", JSON.stringify(response));
        state.current_user = response;
    },
};

// decode url
function decode($base64) {
    let encodedPath = $base64; //base64decode(strtr($base64, '-', '+/'));
    encodedPath = encodedPath.replace("-", "+/");
    if (atob(encodedPath)) {
        encodedPath = atob(encodedPath);
    } else {
        encodedPath = "";
    }
    return encodedPath;
}

function encode($data) {
    let encodedPath = btoa($data);
    // console.log('in encode', $data, encodedPath);
    encodedPath = encodedPath.replace(/=+$/, "");
    encodedPath = encodedPath.replace("+/", "-");
    encodedPath = encodedPath.trimEnd();
    return encodedPath; //strtr(rtrim(base64encode($data), '='), '+/', '-');
}
export default {
    state,
    getters,
    actions,
    mutations,
};
